import Tests from './Tests.vue';

export * from './types';
export default Tests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/tests/index.ts